export default __webpack_public_path__ + "static/media/close.c198590e.svg";